import * as defaultImport from "@splunk/react-ui/Dropdown";
export * from "@splunk/react-ui/Dropdown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
